import { render, staticRenderFns } from "./SnackbarEx.vue.js?vue&type=template&id=de5216dc!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarEx.vue?vue&type=template&id=de5216dc"
import script from "./SnackbarEx.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarEx.vue?vue&type=script&lang=ts"
export * from "./SnackbarEx.vue.ts?vue&type=script&lang=ts!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SnackbarEx.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports